<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <foody_general_tab :location="location"></foody_general_tab>
        </template>

    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import foody_general_tab from "./tabs/foody_general_tab";


export default {
    name: "foody_location_modal",
    components : {
        foody_general_tab,
        base_location_modal,
    },
    data () {
        return {
            tabs_add : [

            ]
        }
    },
}
</script>

<style scoped>

</style>
